export class WatchdogUtil {
  /** Internally track all active interval handles */
  private static readonly active = new Set<ReturnType<typeof setInterval>>();

  /**
   * Launch a watchdog.
   * Returns a `stop()` function that cancels this specific watchdog.
   */
  public static startWatchdog(timeoutMs: number, intervalMs: number, onExpire: () => void): () => void {
    const start = Date.now();
    let fired = false;

    const handle = setInterval(() => {
      if (fired) return;

      const elapsed = Date.now() - start;
      if (elapsed >= timeoutMs) {
        fired = true;
        WatchdogUtil.clearTimer(handle);
        onExpire();
      }
    }, intervalMs);

    WatchdogUtil.active.add(handle);

    const stop = (): void => WatchdogUtil.clearTimer(handle);
    return stop;
  }

  /**
   * Clear a specific timer (if given) or *all* timers.
   */
  public static clearTimer(handle?: ReturnType<typeof setInterval>): void {
    if (handle !== undefined) {
      clearInterval(handle);
      WatchdogUtil.active.delete(handle);
    } else {
      WatchdogUtil.active.forEach((h) => clearInterval(h));
      WatchdogUtil.active.clear();
    }
  }
}
